import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import pages from './routes/pages'
import app from './routes/app'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'auth-login' } },
    ...pages,
	...app,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  // if (to.redirectedFrom === '/') return next({ name: 'auth-login' })

  // Garde d'accès à l'espace admin DOMICIALIZ (auth indépendante du client).
  const isDomAdmin = !!localStorage.getItem('domAdminToken')
  if (to.meta && to.meta.requiresDomAdmin && !isDomAdmin) {
    return next({ name: 'admin-dom-login' })
  }
  if (to.meta && to.meta.requiresDomAdminGuest && isDomAdmin) {
    return next({ name: 'admin-dom-dossiers' })
  }
  if (to.meta && to.meta.requiresDomSuperAdmin) {
    let isSuper = false
    try {
      const data = JSON.parse(localStorage.getItem('domAdminData') || '{}')
      isSuper = !!data.superadmin
    } catch (e) { /* ignore */ }
    if (!isSuper) return next({ name: 'admin-dom-dossiers' })
  }
  // Les routes admin (login inclus) court-circuitent la logique CASL client.
  if (to.meta && (to.meta.requiresDomAdmin || to.meta.requiresDomAdminGuest)) {
    return next()
  }

  const isLoggedIn = isUserLoggedIn()
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
